'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isArray = isArray;
exports.parse2ObjVal = parse2ObjVal;
exports.parse2StrVal = parse2StrVal;
exports.valCompare = valCompare;
exports.parseValue = parseValue;
exports.getTreeLevel = getTreeLevel;
exports.parseOptions = parseOptions;
exports.removeChildren = removeChildren;
exports.removeChildrenL2 = removeChildrenL2;
exports.convertDataSource = convertDataSource;

var _lodash = require('lodash');

var _i18nTransform = require('@ali/i18n-transform');

var _i18nTransform2 = _interopRequireDefault(_i18nTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// 此方法对数组的判断不够严谨，但在此场景下够用了
function isArray(arr) {
  return arr instanceof Array;
}
function parse2ObjVal(options, value, size) {
  var cursor = options;
  value = JSON.parse(JSON.stringify(value || []));

  var _loop = function _loop(deep) {
    var index = 0;
    cursor.forEach && cursor.forEach(function (o, i) {
      var val = value[deep];
      if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && 'value' in val) {
        val = value[deep].value;
      }
      if (o.value === val) {
        index = i;
        value[deep] = {
          value: o.value,
          text: o.label
        };
      }
    });
    cursor = cursor[index] ? cursor[index].children : null;
  };

  for (var deep = 0; cursor && deep < size; deep++) {
    _loop(deep);
  }
  return value;
}

function parse2StrVal(value) {
  return value && isArray(value) ? value.map(function (v) {
    return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && 'value' in v ? v.value : v;
  }) : [];
}

function valCompare(a, b) {
  if ((typeof b === 'undefined' ? 'undefined' : _typeof(b)) === 'object' && 'value' in b) {
    return a === b.value;
  }
  return a === b;
}

function parseValue(options, value, size) {
  var cursor = options;
  value = value || [];

  var _loop2 = function _loop2(deep) {
    var index = 0;
    cursor.forEach(function (o, i) {
      var val = value[deep];
      if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && 'value' in value[deep]) {
        val = value[deep].value;
      }
      if (o.value === val) {
        index = i;
        value[deep] = {
          value: o.value,
          text: o.label
        };
      }
    });
    cursor = cursor[index] ? cursor[index].children : null;
  };

  for (var deep = 0; cursor && deep < size; deep++) {
    _loop2(deep);
  }
  return value;
}

var getLevel = function getLevel(ary, level) {
  var levels = ary.filter(function (o) {
    return Array.isArray(o.children);
  }).map(function (o) {
    return getLevel(o.children, level);
  });
  var max = void 0;
  if (levels.length > 0) {
    max = Math.max.apply(null, levels);
  } else {
    max = 0;
  }
  return max + level;
};

function getTreeLevel(data) {
  return getLevel(data, 1);
}

/**
 * 组件需要的 options 是 {label, value, children}
 * 需要兼容传进的数据为 {text, value, children}
 * @param {*} options
 */
function parseOptions(options) {
  if (options === null || options === undefined || !options.map) {
    return options;
  }
  // TODO
  var newOptions = options.filter(function (item) {
    return !!item;
  }).map(function (item) {
    var newItem = {
      value: item.id,
      label: item.name,
      parent: item.parentId,
      matterId: item.matterId,
      level: item.level,
      selectFlag: item.selectFlag,
      disabled: !item.selectFlag ? true : false
    };
    if (!(0, _lodash.isEmpty)(item.children)) {
      newItem.children = parseOptions(item.children);
    }
    return newItem;
  });
  return newOptions;
}

function removeChildren(data) {
  var ds = [].concat(_toConsumableArray(data));
  ds.forEach(function (item) {
    if (item.children) delete item.children;
  });
  return ds;
}

function removeChildrenL2(data) {
  var ds = [].concat(_toConsumableArray(data));
  ds.forEach(function (item) {
    if (item.children) {
      item.children.forEach(function (subItem) {
        if (subItem.children) {
          delete subItem.children;
        }
      });
    }
  });
  return ds;
}

function convertDataSource(options) {
  var maxLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;

  if ((0, _lodash.isEmpty)(options)) {
    return [];
  }
  return options.map(function (item) {
    return {
      value: item.id,
      label: item.name,
      parent: item.parentId,
      matterId: item.matterId,
      level: item.level,
      selectFlag: item.selectFlag,
      isLeaf: !item.selectFlag ? true : item.level >= maxLevel,
      disabled: !item.selectFlag ? true : false

      // isLeaf: item.level >= maxLevel
    };
  });
}